module.exports = __webpack_public_path__ + "static/media/partner-logo-BackBlaze.e5047add.svg";